import React, { createContext, useContext, useState } from 'react';

const BorradoresContext = createContext();

export function BorradoresProvider({ children }) {
    const [borradores, setBorradores] = useState([]);
    const [listoParaDesplegar, setListoParaDesplegar] = useState([]);

    const agregarABorradores = (mueble) => {
        setBorradores((prevBorradores) => [...prevBorradores, mueble]);
    };

    const agregarAListoParaDesplegar = (mueble) => {
        setListoParaDesplegar((prevListoParaDesplegar) => [
            ...prevListoParaDesplegar,
            mueble,
        ]);
    };

    const eliminarDeBorradores = (referencia, mueble) => {
        setBorradores((prevBorradores) =>
            prevBorradores.filter(
                (borrador) => borrador.referencia !== referencia
            )
        );
    };

    const eliminarDeListoParaDesplegar = (referencia) => {
        const updatedListoParaDesplegar = listoParaDesplegar.filter(
            (item) => item.referencia !== referencia
        );
        setListoParaDesplegar(updatedListoParaDesplegar);
    };

    return (
        <BorradoresContext.Provider
            value={{
                borradores,
                agregarABorradores,
                listoParaDesplegar,
                agregarAListoParaDesplegar,
                eliminarDeBorradores,
                eliminarDeListoParaDesplegar
            }}
        >
            {children}
        </BorradoresContext.Provider>
    );
}

export function useBorradores() {
    return useContext(BorradoresContext);
}
